import * as React from "react";
import ImageHolder from "common/components/imageHolder";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import cx from "classnames";

const classStyles = require("./tinySquareStackedImage.scss");

interface IProps {
  width: number;
  height: number;
  src?: string;
  color?: string;
  title?: string;
  alt?: string;
  className?: string;
  wrapperStyles?: React.CSSProperties;
  imgStyles?: React.CSSProperties;
  isPrivate?: boolean;
  privateIconWrapperClassName?: string;
  privateIconClassName?: string;
  borderOneWidth?: number;
  borderTwoWidth?: number;
}

const TOP_BOTTOM_MARGIN: number = 5;
const SIDE_MARGIN: number = 5;

const TinySquareStackedImage = ({
  width,
  height,
  src,
  color,
  title,
  className,
  wrapperStyles,
  imgStyles,
  isPrivate,
  alt = src,
  borderOneWidth,
  borderTwoWidth,
  privateIconWrapperClassName,
  privateIconClassName,
}: IProps) => {
  const styles = {
    width,
    height,
  };

  const imageStyles = {
    width: width - TOP_BOTTOM_MARGIN,
    height: height - SIDE_MARGIN,
    borderRadius: 2,
  };

  const borderStyles1 = {
    width: borderOneWidth ? borderOneWidth : width - 13,
  };

  const borderStyles2 = {
    width: borderTwoWidth ? borderTwoWidth : width - 21,
  };

  const finalWrapperStyles = { ...styles, ...wrapperStyles };
  const finalImgStyles = { ...imageStyles, ...imgStyles };

  let imagePlace: React.ReactNode | null = null;
  if (src) {
    imagePlace = (
      <ImageHolder
        style={finalImgStyles}
        src={src}
        alt={alt}
        width="100%"
        height="100%"
      />
    );
  } else {
    imagePlace = (
      <div
        style={{ ...finalImgStyles, backgroundColor: color }}
        className={classStyles.charWrapper}
      >
        <span className={classStyles.thumbChar}>
          {title ? title.substr(0, 1) : ""}
        </span>
      </div>
    );
  }

  return (
    <div className={className} style={finalWrapperStyles} role="button">
      <div className={classStyles.imageWrapper} style={finalImgStyles}>
        {imagePlace}
        {isPrivate ? (
          <div className={cx(classStyles.private, privateIconWrapperClassName)}>
            <IconWrapper
              icon={PACKS.GENERAL.PRIVATE_COLLECTION_MEDIUM_WHITE_ICON}
              className={cx(classStyles.icon, privateIconClassName)}
            />
          </div>
        ) : null}
      </div>
      <div className={classStyles.border1} style={borderStyles1} />
      <div className={classStyles.border2} style={borderStyles2} />
    </div>
  );
};

export default TinySquareStackedImage;
